import { Button } from '@app/shared';
import { declensionFactory } from '@helpers/declension';
import { ButtonSize, ButtonThemes } from '@sharedUi/ui-kit/Button';
import { Children, FC, useCallback, useState } from 'react';
import { WrapperTableTypeProps } from './TypeProps';
import { IconChevronDown } from '@koleso-icons';
import classNames from 'classnames';

import styles from './WrapperTable.module.scss';

export const WrapperTable: FC<WrapperTableTypeProps> = ({
  classNameTable,
  classNameRow,
  children,
  title,
  elementId,
  maxCountElement = 5,
  hideMaxElement,
}) => {
  const [showAll, setShowAll] = useState<boolean>(false);
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const countElement = Children.count(children);
  const getTitle = declensionFactory('центр', 'центра', 'центров');
  const flag = hideMaxElement && countElement > maxCountElement && !showAll;

  const handlerShowAllElements = useCallback(() => {
    setShowAll(true);
    setIsClicked(true);
  }, []);

  return (
    <div id={elementId} className={styles.Wrapper}>
      {title}
      <div className={classNames(styles.WrapperTable, classNameTable)}>
        {flag
          ? Children.map(children, (child, index) => {
              return (
                <div
                  className={classNames(styles.WrapperRowTable, classNameRow, {
                    [styles.Animate]: isClicked && index >= maxCountElement,
                  })}
                  style={{
                    animationDelay: (index >= maxCountElement ? 5 : 0) + (index >= maxCountElement ? (index - 5) * 150 : 0) + 'ms',
                  }}
                >
                  {child}
                </div>
              );
            }).slice(0, maxCountElement)
          : Children.map(children, (child, index) => {
              return (
                <div
                  className={classNames(styles.WrapperRowTable, classNameRow, {
                    [styles.Animate]: isClicked && index >= maxCountElement,
                  })}
                  style={{
                    animationDelay: (index >= maxCountElement ? 5 : 0) + (index >= maxCountElement ? (index - 5) * 150 : 0) + 'ms',
                  }}
                >
                  {child}
                </div>
              );
            })}
      </div>
      {flag && (
        <Button size={ButtonSize.S} themes={ButtonThemes.Black} className={styles.ButtonShow} onClick={handlerShowAllElements}>
          {`Показать ещё ${countElement - maxCountElement} ${getTitle(countElement - maxCountElement)}`}
          <IconChevronDown width={16} height={16} />
        </Button>
      )}
    </div>
  );
};
